import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=12ec4dbd&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=12ec4dbd&lang=scss&scoped=true&"
import style1 from "./Main.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec4dbd",
  null
  
)

export default component.exports